// Binds the plan SightMap control.

SPACES.PlanSightMapTrigger = (function ($) {
  function PlanSightMapTrigger () {
    this.$controlElement = $('[data-spaces-control="plan-sightmap-trigger"]')
  }

  PlanSightMapTrigger.prototype.init = function () {
    const control = this
    control.$controlElement.each(function () {
      const $smTrigger = $(this)
      $smTrigger.on('click', function (e) {
        e.preventDefault()

        if($(this).hasClass('spaces-disabled')) {
          return false
        }

        $(this).addClass('spaces-disabled')

        let ids = $(this).data('spaces-sightmap-filter')
        SPACES.locateUnitIds = String(ids).split(',')
        SPACES.utility.log('SPACES: Plan SightMap requested unit IDs:', SPACES.locateUnitIds)

        if (!SPACES.sightmapLoaded) {
          SPACES.ajaxFactory.getSightMap({ from: 'plan' })
        } else {
          SPACES.spacesModal.open('[data-spaces-control="placeholder"]')
          SPACES.sightmapFactory.embed.setUnitIdMatches(SPACES.locateUnitIds)
          $(this).removeClass('spaces-disabled')
        }
      })
    })
  }

  return PlanSightMapTrigger
})(jQuery)

document.addEventListener('spaces_init', function (e) {
  // Hook into the main SPACES init
  SPACES.planSightMapTrigger = new SPACES.PlanSightMapTrigger()
  SPACES.planSightMapTrigger.init()
})

document.addEventListener('spaces_tab', function (e) {
  // Run init after AJAX tab switch
  SPACES.planSightMapTrigger = new SPACES.PlanSightMapTrigger()
  SPACES.planSightMapTrigger.init()
})
